import React from 'react';
import SarasDnDList from '../../../../library/hooks/bdnd/SarasDnDList';
import ColumnSelectorCol from './ColumnSelectorCol'

const ColumnSelectorDNDList = (props) => {
    const { groupKey, viewData, rowKeys, sarasDnDManager, onToggleVisibility, isHidden } = props;

    const renderDnDRow = (row, index) => {
        let rowData = viewData.columns[row.columnKey];

        return (
            <li className={"uiShrinkInSort uiSpacerL5"}>
                <ColumnSelectorCol index={index} rowKey={row.columnKey} 
                    viewData={rowData} key={index}
                    isHidden={isHidden}
                    onToggleVisibility={onToggleVisibility}
                    groupKey={1} isSortMode={sarasDnDManager.isSortMode()}
                />
            </li>
        )
    }

    return (
        <SarasDnDList groupKey={groupKey} sarasDnDManager={sarasDnDManager} >
            {
                rowKeys && rowKeys.map((row, index) => (
                    renderDnDRow(row, index)
                ))
            }
        </SarasDnDList>
    )
}

export default ColumnSelectorDNDList
